const HEX_REGEXP = /^[-+]?[0-9A-Fa-f]{1,64}\.?[0-9A-Fa-f]{0,64}$/;

export function toHex(value: number, withPrefix = true): string {
  return withPrefix ? addHexPrefix(value.toString(16)) : value.toString(16);
}

export function fromHexToNumber(hex: string): number {
  return +Number(hex);
}

export function addHexPrefix(hex: string): string {
  return !hex.startsWith('0x') ? '0x' + hex : hex;
}

export function shortString(str: string, start = 4, end = 4) {
  const slen = Math.max(start, 1);
  const elen = Math.max(end, 1);

  return str.slice(0, slen + 2) + ' ... ' + str.slice(-elen);
}

export function shortAddress(address: string, start = 4, end = 4) {
  return shortString(addHexPrefix(address), start, end);
}

export function checkAddress(
  address: any,
  options: { leadingZero: boolean } = { leadingZero: true },
): boolean {
  if (typeof address !== 'string') {
    return false;
  }
  let str = address;

  if (options.leadingZero) {
    if (!address.startsWith('0x')) {
      return false;
    } else {
      str = str.substring(2);
    }
  }

  return HEX_REGEXP.test(str);
}

export function checkAptosType(
  type: any,
  options: { leadingZero: boolean } = { leadingZero: true },
): boolean {
  if (typeof type !== 'string') {
    return false;
  }

  let _type = type.replace(/\s/g, '');

  const openBracketsCount = _type.match(/</g)?.length ?? 0;
  const closeBracketsCount = _type.match(/>/g)?.length ?? 0;

  if (openBracketsCount !== closeBracketsCount) {
    return false;
  }

  const genericsString = _type.match(/(<.+>)$/);
  const generics = genericsString?.[1]?.match(
    /(\w+::\w+::\w+)(?:<.*?>(?!>))?/g,
  );

  if (generics) {
    _type = _type.slice(0, _type.indexOf('<'));
    const validGenerics = generics.every((g) => {
      const gOpenCount = g.match(/</g)?.length ?? 0;
      const gCloseCount = g.match(/>/g)?.length ?? 0;
      let t = g;
      if (gOpenCount !== gCloseCount) {
        t = t.slice(0, -(gCloseCount - gOpenCount));
      }

      return checkAptosType(t, options);
    });

    if (!validGenerics) {
      return false;
    }
  }

  const parts = _type.split('::');
  if (parts.length !== 3) {
    return false;
  }

  return (
    checkAddress(parts[0], options) &&
    parts[1].length >= 1 &&
    parts[2].length >= 1
  );
}

export const stringToHexString = (str: string) => {
  const utf8Encode = new TextEncoder();
  const bytes = utf8Encode.encode(str);

  return Array.from(bytes, (byte) => {
    return ('0' + (byte & 0xff).toString(16)).slice(-2);
  }).join('');
};
